import React, { useState } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import './MobileMoneyModal.css';
import axios from 'axios';

const override = {
    borderWidth: 8,
    margin: '0 auto'
};

const SummerMobileMoneyModal = ({ show, onClose, data,registrationData,selectedSchool,selectedTerm,setPaymentStatus , menu_selection, onPaymentConfirmed}) => {
    const [errors, setErrors] = useState({});
    const [loader, SetLoader] = useState(false)
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const [formData, setFormData] = useState({ walletRef: '',  momo_provider: '',});
    if (!show) return null;
    const studentEnteredData = registrationData;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.walletRef.trim()) newErrors.walletRef = 'Enter Registered Mobile Money Number.';
        if (formData.walletRef.length > 11) {
            newErrors.walletRef = 'Enter a valid mobile number';
        }else if(formData.walletRef.length < 10){
            console.log(formData.walletRef.length);
            newErrors.walletRef = 'Wrong mobile number';
        }
        if (!formData.momo_provider.trim()) newErrors.momo_provider = 'Select a provider';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const pollPaymentStatus = async (transactionId) => {
        // const checkPaymentStatusUrl = `https://web-production-d558.up.railway.app/api/checkMomoPaymentStatus?transactionId=${transactionId}`;
        const liveCheckPaymentURL = `https://web-production-d558.up.railway.app/api/checkMomoPaymentStatus?transactionId=${transactionId}`;
        //let tempRegistrationPosted = false; 
        
        // console.log('selected amount => ', parseFloat(response.data.result.amount + selectedTerm.momo));

        let maxRetries = 30; 
        const additionalRetries = 5;
        let attempt = 0;
        let alertShown = false;

        while (attempt < maxRetries) {
            if (attempt === 4 && !alertShown) {
                    alertShown = true;
                    alert(`
                        Hello ${studentEnteredData.parentFullname}, 
                        Kindly Dial *170#, 
                        Select "My Wallet", 
                        Select "My Approvals", 
                        Enter your PIN, 
                        Approve the pending approval.
                    `);
            }
            
            try {
                if (attempt === 4 && !alertShown) {
                    alertShown = true;
                    maxRetries += additionalRetries;
                        alert(`
                            Hello ${studentEnteredData.parentFullname}, 
                            Kindly Dial *170#, Select "My Wallet", 
                            Approve the pending approval.
                        `);
                }
                const response = await axios.get(liveCheckPaymentURL);
                //const data = response.data;

                // if (!tempRegistrationPosted) {
                //     const finalizedFormState = { 
                //         ...studentEnteredData, 
                //         studentshool: selectedSchool.school,
                //         schoolTerm: selectedTerm.term,
                //         SCHOOLCODE: selectedSchool.nu_customer_code
                //     };
                //     const studentRegistrationData = {
                //         ...finalizedFormState,
                //         vc_comp_code: selectedSchool.vc_comp_code,
                //         vc_item_code: selectedTerm.vc_item_code
                //     };

                //     const orderRef = data.result?.transactionId;


                //     const liveTempUrl = "https://web-production-d558.up.railway.app/api/temp/registration-records"
                //     // const testTempUrl = "https://web-production-d558.up.railway.app/api/temp/registration-records"
                //     await axios.post(
                //         liveTempUrl, {orderRef,registrationData: studentRegistrationData}, {timeout: 500000}
                //     )
                //     tempRegistrationPosted = true; 
                // }
    
                if (response.data.result.status === "CONFIRMED") {
                    // const testRegistrationURl = 'https://web-production-d558.up.railway.app/api/summer-camp/registration';
                    const liveRegistrationURL = `https://web-production-d558.up.railway.app/api/summer-camp/registration`

                    const finalizedFormState = { 
                        ...studentEnteredData, 
                        studentshool: selectedSchool.school,
                        schoolTerm: selectedTerm.term,
                        SCHOOLCODE: selectedSchool.nu_customer_code
                    };
                    const studentRegistrationData = {
                        ...finalizedFormState,
                        vc_comp_code: selectedSchool.vc_comp_code,
                        vc_item_code: selectedTerm.vc_item_code
                    };
                    
                    const payment_data = {
                        "payment_amount": response.data.result.amount,
                        "date_of_payment": response.data.result.transactionDate,
                        "paymentRef": response.data.result.paymentChannelReference,
                        "paymentStatus": response.data.result.success ? "SUCCESS" : "FAILED",
                        "payment_type": response.data.result.paymentChannel
                    }

                    await axios.post(liveRegistrationURL, { registration_data: studentRegistrationData, payment_data, menu_selection })
                    
                    return response.data;
                } else if (response.data.result.stutus === "FAILED") {
                    // const testRegistrationURl = 'https://web-production-d558.up.railway.app/api/summer-camp/registration';
                    const liveRegistrationURL = `https://web-production-d558.up.railway.app/api/summer-camp/registration`

                    const finalizedFormState = { 
                        ...studentEnteredData, 
                        studentshool: selectedSchool.school,
                        schoolTerm: selectedTerm.term,
                        SCHOOLCODE: selectedSchool.nu_customer_code
                    };
                    const studentRegistrationData = {
                        ...finalizedFormState,
                        vc_comp_code: selectedSchool.vc_comp_code,
                        vc_item_code: selectedTerm.vc_item_code
                    };
                    
                    const payment_data = {
                        "payment_amount": response.data.result.amount,
                        "date_of_payment": response.data.result.transactionDate ? response.data.result.transactionDate : new Date().toISOString(),
                        "paymentRef": response.data.result.paymentChannelReference ? response.data.result.paymentChannelReference : response.data.result.orderId,
                        "paymentStatus": response.data.result.success ? "SUCCESS" : "FAILED",
                        "payment_type": "Mobile Money"
                    }  
                    await axios.post(
                        liveRegistrationURL,
                        { registration_data: studentRegistrationData, payment_data, menu_selection },
                    )
                
                    return response.data;
                }
            } catch (error) {
                console.error('Error during polling:', error.response ? error.response.data.message : error.message);
            }
    
            await delay(20000);
            attempt++;
        }

        return false;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (validateForm()) {
            SetLoader(true);
            // const testUrl = `https://web-production-d558.up.railway.app/api/authorize-momo-payment`;
            const liveUrl = 'https://web-production-d558.up.railway.app/api/authorize-momo-payment'
    
            try {
                // Backend authorizeMobilePayment expects:
                // - formData.momo_provider
                // - formData.walletRef
                // - formData.parentNumber
                // This modal only collects walletRef + momo_provider, so we inject parentNumber from registrationData.
                if (!registrationData?.parentNumber) {
                    SetLoader(false);
                    setErrors((prev) => ({
                        ...prev,
                        walletRef: prev.walletRef || "Parent mobile number is missing. Please go back and re-check the form.",
                    }));
                    return;
                }

                const parentNumber = registrationData?.parentNumber;

                if (!parentNumber || !String(parentNumber).trim()) {
                    SetLoader(false);
                    setErrors((prev) => ({
                        ...prev,
                        walletRef:
                            prev.walletRef ||
                            "Parent phone number is missing. Please go back and re-check Parent / Guardian Details.",
                    }));
                    return;
                }

                // Debug: log exact values being sent (useful for MoMo 400 validation)
                console.log("[SummerMobileMoneyModal] authorize-momo-payment provider/wallet:", {
                    momo_provider: formData?.momo_provider,
                    walletRef: formData?.walletRef,
                    parentNumber: parentNumber,
                    selectedTerm: selectedTerm?.term ?? null,
                    selectedTermNuPrice: selectedTerm?.nu_price ?? null,
                    selectedTermMomo: selectedTerm?.momo ?? null,
                });

                // Also log payload-shape sanity (non-sensitive)
                console.log("[SummerMobileMoneyModal] authorize-momo-payment payload preview:", {
                    providerProvided: Boolean(formData?.momo_provider),
                    walletRefProvided: Boolean(formData?.walletRef),
                    selectedTermProvided: Boolean(selectedTerm),
                    selectedTermAmountPreview:
                        selectedTerm && (selectedTerm.nu_price ?? selectedTerm.momo)
                            ? `${selectedTerm.nu_price ?? ""}+${selectedTerm.momo ?? ""}`
                            : "missing",
                    parentNumberProvided: true,
                    registrationDataKeys: Object.keys(registrationData || {}),
                });

                const response = await axios.post(liveUrl, {
                    registrationData,
                    selectedSchool,
                    selectedTerm,
                    formData: {
                        ...formData,
                        parentNumber: String(parentNumber),
                    },
                });

                if (response.status === 200) {
                const { transactionId } = response.data;
                if(transactionId){
                 const finalizedFormState = { 
                        ...studentEnteredData, 
                        studentshool: selectedSchool.school,
                        schoolTerm: selectedTerm.term,
                        SCHOOLCODE: selectedSchool.nu_customer_code
                    };
                    const studentRegistrationData = {
                        ...finalizedFormState,
                        vc_comp_code: selectedSchool.vc_comp_code,
                        vc_item_code: selectedTerm.vc_item_code
                    };
                    const orderRef = transactionId;

                    // Prevent backend mongoose validation errors (studentID is required)
                    // if (!studentRegistrationData?.studentID || !String(studentRegistrationData.studentID).trim()) {
                    //     SetLoader(false);
                    //     setErrors((prev) => ({
                    //         ...prev,
                    //         walletRef: prev.walletRef || '',
                    //     }));
                    //     alert("Student ID is missing. Please go back and enter the Student ID, then try Mobile Money again.");
                    //     onClose();
                    //     return;
                    // }

                    const liveTempUrl = "https://web-production-d558.up.railway.app/api/temp/registration-records"
                    // const testTempUrl = "https://web-production-d558.up.railway.app/api/temp/registration-records"
                    await axios.post(
                        liveTempUrl, {orderRef,registrationData: studentRegistrationData}, {timeout: 500000}
                    )
                    
                    
                if (response.data.data.result.status === "PENDING") {
                    const pollResponse = await pollPaymentStatus(transactionId);

                    if (pollResponse.success) {
                        onClose();
                        setPaymentStatus('SUCCESS');
                        SetLoader(false); 
                    }else{
                        onClose();
                        setPaymentStatus('FAILED');
                        SetLoader(false);
                        setPaymentStatus("An Error occurred whilst process your payment payment"); 
                    }
                    console.log('the polling response =>',pollResponse)
                }else{
                    console.log('still pending');
                }
            }
            }
            } catch (error) {
                console.log('There was an error ', error);
            } finally {
                SetLoader(false);
            }
        } else {
            console.log(errors);
        }
    };

    const handlCloseMobileModel = async () => {
        onClose()
        window.location.reload()
    }
    

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <span className="close-modal" onClick={handlCloseMobileModel}>&times;</span>
                <h4 className='momo_form_header'>Available Mobile Money Providers</h4>
                <div className="modal-images">
                    {
                        data.map((item, index) => (
                            <img key={index} src={item.logo} alt={`mobile money ${index + 1}`} className="modal-image" />
                        ))
                    }
                </div>
                
                <div className="momo_form-container">
                    
                    <form onSubmit={handleSubmit}>
                        <div className="field">
                            <div className="momo_labels">Select Provider</div>
                            <select 
                                name="momo_provider" 
                                id="momo_type" 
                                // className='mobile_money_select'  
                                onChange={handleChange}
                                value={formData.momo_provider}
                                className={`mobile_money_select ${errors.momo_provider ? 'input-error' : ''}` }
                            >
                                <option value="" defaultValue >Select Provider</option>
                                {
                                    data.map((item, index) => (
                                        <option key={index}  value={item.provider}>{item.name}</option>
                                    ))
                                }
                            </select>
                        </div>
                        
                        <div className="field">
                            <div className="momo_labels">Enter Momo Number</div>
                                <input 
                                    type="number" 
                                    name="walletRef" 
                                    placeholder='Enter Mobile Money Number' 
                                    className={`mobile_money_input ${errors.walletRef ? 'input-error' : ''}` }
                                    value={formData.walletRef} 
                                    onChange={handleChange}
                                />
                        </div>

                        {
                                loader ? (<ClipLoader
                                    color={"hsl(118, 45%, 51%)"}
                                    cssOverride={override}
                                    loading={loader}
                                    size={50}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                />) : <>
                                    <input type="submit" className='momo-auth-button' value="Authorize Payment"/>
                                </>
                            }

                        
                    </form>
                </div>

            </div>
        </div>
    );
};

export default SummerMobileMoneyModal;
